import { useMemo } from 'react'

export default function useTreatedFieldChips(
  types,
  selectedFields,
  selectedTempChips,
  lockedTempChips,
  translationFunc
) {
  const fieldChipData = useMemo(() => translationFunc(types), [types, translationFunc])

  const treatedFieldChipData = useMemo(() => {
    const chipsInUse = selectedTempChips.concat(lockedTempChips)
    // keep in sync the disabled/enabled state of each name field chip (can only select each one once)
    // get an array of fieldTypes from chips the user has selected
    const selectedTempChipFieldTypes = chipsInUse.map((f) => f?.value.split(':')[0])
    // attach fieldType to chips from pre-existing fields
    const enhancedSelectedTempChips = chipsInUse.map((c) => {
      return {
        ...c,
        fieldType: selectedFields.find((f) => f?.id === c?.id)?.fieldType,
      }
    })
    // name chips added while on this panel (not saved in SLS yet)
    const addedFieldTypes = selectedFields.filter((field) => field.added).map((field) => field.fieldType)

    return fieldChipData?.map((chip) => {
      const { elementTypes, ...rest } = chip
      const chipFieldType = selectedTempChipFieldTypes.includes(chip.value)
        ? chip.value
        : enhancedSelectedTempChips.find((f) => f?.fieldType === chip?.value)?.fieldType
      return {
        ...rest,
        elementtypes: elementTypes, // To avoid the error on react of elementType is not a valid prop
        disabled: Boolean(chipFieldType) || addedFieldTypes.includes(chip.value),
      }
    })
  }, [selectedFields, fieldChipData, selectedTempChips, lockedTempChips])
  return { treatedFieldChipData }
}
